import { tone } from '@chakra-ui/theme-tools'
import { Z_INDEX } from 'constants/common'

export const Avatar = {
  baseStyle: ({ bg, theme }: { bg: string; theme: Record<string, string> }) => {
    const isDarkBg = tone(bg)(theme) === 'dark'

    return {
      container: {
        bg,
        color: isDarkBg ? 'white' : 'black',
      },
      // This fixed issue with react-d3-tree library in safari,
      // where avatar component was displayed on position x:0, y:0
      // https://github.com/bkrem/react-d3-tree/issues/284
      excessLabel: {
        position: 'static',
        color: 'gray.800',
        zIndex: Z_INDEX.EXCESS_LABEL,
      },
    }
  },
  sizes: {
    product: { container: { width: 10, height: 10, fontSize: 'sm' } },
    sm: {
      label: {
        fontSize: 'xs',
      },
    },
  },
}
